import React from "react";
import { motion } from "framer-motion";
import { SPONSORS, PARTNERS } from "../../lib/winners";

function LogoTile({ item, big, i }) {
  return (
    <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
      className={`group flex items-center justify-center rounded-2xl bg-white/[0.04] ring-1 ring-white/10 transition-colors duration-300 hover:bg-white/[0.08] hover:ring-gold-500/40 ${big ? "h-28 px-6 md:h-36" : "h-20 px-4 md:h-24"}`}
      data-testid={`sponsor-${item.name.replace(/\s/g, "-").toLowerCase()}`}>
      <img src={item.src} alt={item.name} loading="lazy"
        className={`w-auto object-contain opacity-90 transition-transform duration-300 group-hover:scale-105 group-hover:opacity-100 ${item.tall ? "max-h-14" : item.small ? "max-h-6 md:max-h-8" : big ? "max-h-9 md:max-h-11" : "max-h-7 md:max-h-8"} max-w-full`} />
    </motion.div>
  );
}

export function SponsorWall() {
  return (
    <section className="relative mx-auto w-full max-w-6xl px-4 py-14 md:py-20" data-testid="sponsors-section">
      <p className="font-mono text-[12px] font-bold uppercase tracking-[0.3em] text-gold-400">With gratitude</p>
      <h2 className="mt-2 font-display text-[40px] font-extrabold uppercase leading-[0.9] text-white sm:text-[56px]">Our sponsors</h2>
      <p className="mt-3 max-w-xl text-[15px] text-on-dark-muted">The prizes, the tools and the late-night fuel came from these teams. Thank you for backing the builders.</p>
      <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3 md:gap-4">
        {SPONSORS.map((s, i) => <LogoTile key={s.name} item={s} big i={i} />)}
      </div>
      <p className="mt-12 font-mono text-[12px] font-bold uppercase tracking-[0.3em] text-sky-500">Associated with</p>
      <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4">
        {PARTNERS.map((s, i) => <LogoTile key={s.name} item={s} i={i} />)}
      </div>
      <div className="mt-10 flex items-center justify-center gap-3 text-on-dark-muted" data-testid="powered-by">
        <span className="text-[13px]">Powered by</span>
        <img src="/assets/winners/logo-utopia.webp" alt="u-topia" className="h-7 w-auto" />
      </div>
    </section>
  );
}
